import { PREVIEW_FINISHED } from '../../action-types/ui/previewFinished';

export const isPreviewFinished = status => ({
  type: PREVIEW_FINISHED,
  status,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/previewFinished.js